import { createServerFn } from "@tanstack/react-start";
import {
    type ManagedAccountMutationResult,
    ManagedAccountIdSchema,
    UpdateManagedAccountPasswordSchema,
} from "./managed-accounts.contract";
import {
    decideManagedAccountData,
    deleteManagedAccountData,
    listManagedAccountsData,
    revealManagedAccountPasswordData,
    updateManagedAccountPasswordData,
} from "./managed-accounts.server";

export const listManagedAccounts = createServerFn({ method: "GET" }).handler(
    () => listManagedAccountsData(),
);

export const approveManagedAccount = createServerFn({ method: "POST" })
    .inputValidator((input: { id: string }) =>
        ManagedAccountIdSchema.parse(input),
    )
    .handler(({ data }) => decideManagedAccountData(data.id, "approve"));

export const denyManagedAccount = createServerFn({ method: "POST" })
    .inputValidator((input: { id: string }) =>
        ManagedAccountIdSchema.parse(input),
    )
    .handler(({ data }) => decideManagedAccountData(data.id, "deny"));

export const revealManagedAccountPassword = createServerFn({ method: "POST" })
    .inputValidator((input: { id: string }) =>
        ManagedAccountIdSchema.parse(input),
    )
    .handler(({ data }) => revealManagedAccountPasswordData(data.id));

export const updateManagedAccountPassword = createServerFn({ method: "POST" })
    .inputValidator((input: { id: string; password: string }) => {
        const parsed = UpdateManagedAccountPasswordSchema.safeParse(input);
        return parsed.success
            ? { valid: true as const, ...parsed.data }
            : { valid: false as const };
    })
    .handler(async ({ data }): Promise<ManagedAccountMutationResult> => {
        if (!data.valid) return { status: "invalid" };
        try {
            return await updateManagedAccountPasswordData(
                data.id,
                data.password,
            );
        } catch {
            return { status: "failed" };
        }
    });

export const deleteManagedAccount = createServerFn({ method: "POST" })
    .inputValidator((input: { id: string }) =>
        ManagedAccountIdSchema.parse(input),
    )
    .handler(({ data }) => deleteManagedAccountData(data.id));
